var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, color = _a.color, htmlAttributes = __rest(_a, ["className", "color"]);
    return (React.createElement("svg", __assign({ width: "20.33", height: "20", viewBox: "0 0 20.33 20", className: className }, htmlAttributes),
        React.createElement("path", { "data-name": "Icon metro-chart-dots", d: "M4.734,19.717H22.9v2.211H2.571v-20H4.734Zm3.554-1.271a1.906,1.906,0,0,1,0-3.812c.056,0,.112,0,.167.008L10.5,11.227a1.906,1.906,0,1,1,3.193,0l2.049,3.415q.083-.007.167-.008c.042,0,.084,0,.126,0L19.421,8.72a1.906,1.906,0,1,1,1.574.832c-.042,0-.084,0-.126,0l-3.382,5.919a1.906,1.906,0,1,1-3.171.034l-2.049-3.414c-.055,0-.11.008-.167.008s-.112,0-.167-.008L9.885,15.5a1.906,1.906,0,0,1-1.6,2.946Z", transform: "translate(-2.571 -1.928)", fill: color })));
});
